import React, { useEffect, useState } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { supabase } from "@/integrations/supabase/client";
import { Capacitor } from "@capacitor/core";


function compareVersions(a, b) {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    if ((pa[i] || 0) > (pb[i] || 0)) return 1;
    if ((pa[i] || 0) < (pb[i] || 0)) return -1;
  }
  return 0;
}

const comparePlatform = (platform1,platform2) =>{
  return platform1 === platform2;
}

export function useForceUpdateCheck() {
  const [forceUpdate, setForceUpdate] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const platform = Capacitor.getPlatform();

  useEffect(() => {
    let cancelled = false;

    async function checkVersion() {
      try {
        if (Capacitor.getPlatform() === 'web'){
            setIsChecking(false);
            return;
        } 


        const appInfo = await CapacitorApp.getInfo();
        const localVersion = appInfo.version;
        // Appel API qui retourne la version minimale requise
        const { data, error: queryError } = await supabase
                .from('app_system')
                .select('last_version,platform')
                .eq('platform', platform)
                .eq('app_name', appInfo.name)
                .single();

        if (queryError) throw queryError;

        const minVersion = data?.last_version;

        if (!cancelled && compareVersions(localVersion, minVersion) < 0) {
          setForceUpdate(true);
        }
      } catch (e) {
        // En cas d’erreur, tu peux soit bloquer, soit laisser passer
        if (!cancelled) setForceUpdate(false);
      } finally {
        if (!cancelled) setIsChecking(false);
      }
    }

    checkVersion();

    return () => {
      cancelled = true;
    };
  }, [platform]);

  return { forceUpdate, isChecking };
}
